import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputLabel,
} from "@mui/material";
import React, { useState } from "react";
import { useSnackbar } from "../../contexts/SnackbarContext";
import { useOrganisations } from "../../hooks/useOrganisations";
import { useUpdateDeviceOwnership } from "../../hooks/useDevices";

export default function DeviceChangeOwnership(props) {
  const { open, handleClose, device } = props;

  const [newOrganisation, setNewOrganisation] = useState(null);

  const { data: organisations = [] } = useOrganisations();
  const updateDeviceOwnershipMutation = useUpdateDeviceOwnership();
  const { showSuccess, showError } = useSnackbar();

  const updateOwnership = async () => {
    if (!newOrganisation) {
      showError("Please select a new organisation");
      return;
    }

    updateDeviceOwnershipMutation.mutate(
      {
        deviceId: device.id,
        organisationId: newOrganisation.id,
      },
      {
        onSuccess: (data) => {
          showSuccess("Device ownership changed successfully");
          handleClose();
        },
        onError: (error) => {
          const errorMessage =
            error.response?.data?.detail ||
            error.message ||
            "Error changing device ownership";
          showError(errorMessage);
        },
      }
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Change Device Ownership</DialogTitle>
      <DialogContent>
        <InputLabel htmlFor="current-organisation">
          Current Organisation
        </InputLabel>
        <TextField
          id="current-organisation"
          value={
            device && device.organisation ? device.organisation.name : "N/A"
          }
          fullWidth
          disabled
        />
        <InputLabel htmlFor="new-organisation" sx={{ mt: 2 }}>
          New Organisation
        </InputLabel>
        <Autocomplete
          id="new-organisation"
          options={organisations}
          onChange={(event, newValue) => {
            setNewOrganisation(newValue);
          }}
          getOptionLabel={(option) => option.id + " " + option.name}
          sx={{ width: "100%", mt: 1 }}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="success"
          onClick={updateOwnership}
          disabled={!newOrganisation || updateDeviceOwnershipMutation.isPending}
          autoFocus
        >
          {updateDeviceOwnershipMutation.isPending ? "Changing..." : "Change"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
